import createEmotionCache, { EmotionCache } from '@emotion/cache';

export type { EmotionCache };

export const createCache = (nonce?: string, container?: Node): EmotionCache =>
  createEmotionCache({ key: 'css', nonce, container });
